import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

import { ButtonComponent, HeadingComponent } from '@core/user-interface-legacy';

import { ApprovalPayload, ApprovalResume, ToolApprovalPayload } from '../schemas';

@Component({
  selector: 'tellent-assistant-approval-interrupt',
  standalone: true,
  imports: [ButtonComponent, HeadingComponent, JsonPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'region', 'aria-label': 'Approval required' },
  template: `
    @if (toolPayload(); as p) {
      <rt-heading variant="subheading" class="prompt">
        {{ p.toolName }} — {{ p.toolDescription }}
      </rt-heading>
      <blockquote class="draft">{{ p.previewText }}</blockquote>
      <rt-button
        variant="tertiary"
        size="small"
        class="args-toggle"
        (click)="showArgs.set(!showArgs())"
      >
        {{ showArgs() ? 'Hide details' : 'Show details' }}
      </rt-button>
      @if (showArgs()) {
        <pre class="args">{{ p.args | json }}</pre>
      }
    } @else if (approvalPayload(); as p) {
      <rt-heading variant="subheading" class="prompt">{{ p.prompt }}</rt-heading>
      @if (p.draft) {
        <blockquote class="draft">{{ p.draft }}</blockquote>
      }
    }
    @if (!resolved()) {
      <footer class="actions">
        <rt-button variant="tertiary" size="small" (click)="reject()">Reject</rt-button>
        <rt-button variant="primary" size="small" (click)="approve()">Approve</rt-button>
      </footer>
    }
  `,
  styleUrls: ['./approval-interrupt.component.less'],
})
export class TellentAssistantApprovalInterruptComponent {
  public readonly payload = input.required<ApprovalPayload | ToolApprovalPayload>();
  public readonly resolved = input<boolean>(false);
  public readonly resolve = output<ApprovalResume>();
  public readonly cancel = output<void>();

  protected readonly toolPayload = computed<ToolApprovalPayload | null>(() => {
    const p = this.payload();
    return 'toolName' in p ? p : null;
  });
  protected readonly approvalPayload = computed<ApprovalPayload | null>(() => {
    const p = this.payload();
    return 'toolName' in p ? null : p;
  });
  protected readonly showArgs = signal(false);

  protected approve(): void {
    this.resolve.emit({ approved: true });
  }

  protected reject(): void {
    this.resolve.emit({ approved: false });
  }
}
